/** Whether a field name/label suggests multiline content (body, script, etc.). */
export function isExpectedMultilineField(fieldName: string, fieldLabel: string): boolean {
    const lowerName = fieldName?.toLowerCase() || '';
    const lowerLabel = fieldLabel?.toLowerCase() || '';
    const multilineFieldNames = ['body', 'content', 'description', 'script', 'config', 'html', 'markdown', 'md'];
    const multilineFieldLabelKeywords = ['description', 'script', 'body', 'content', 'html', 'markdown'];
    return (
        multilineFieldNames.includes(lowerName) ||
        multilineFieldLabelKeywords.some((keyword) => lowerLabel.includes(keyword))
    );
}

/** Detect leading/trailing or embedded whitespace issues for single-line fields. */
export function getWhitespaceIssues(val: string): string[] {
    const issues: string[] = [];
    if (!val || typeof val !== 'string') return issues;
    if (val.includes('\n')) issues.push('contains newline (\\n)');
    if (val.includes('\r')) issues.push('contains carriage return (\\r)');
    if (val.startsWith('\t')) issues.push('starts with tab');
    if (val.endsWith('\t')) issues.push('ends with tab');
    if (val.length > 0) {
        const firstChar = val[0];
        const lastChar = val[val.length - 1];
        const nonStandardWhitespaceRegex = /[\u00A0\u1680\u2000-\u200B\u202F\u205F\u3000\uFEFF]/;
        if (nonStandardWhitespaceRegex.test(firstChar)) {
            const charCode = firstChar.charCodeAt(0).toString(16).toUpperCase().padStart(4, '0');
            issues.push(`starts with non-standard whitespace (U+${charCode})`);
        }
        if (nonStandardWhitespaceRegex.test(lastChar)) {
            const charCode = lastChar.charCodeAt(0).toString(16).toUpperCase().padStart(4, '0');
            issues.push(`ends with non-standard whitespace (U+${charCode})`);
        }
    }
    return issues;
}

export function hasWhitespaceIssues(val: string): boolean {
    return getWhitespaceIssues(val).length > 0;
}
